import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Title from '../../title';
import Single from './single';
import Multiple from './multiple';
import Report from './report';
import Permission from '../../../functions/permission';

function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
});

class Addmenu extends React.Component {
  state = {
    value: 0,
    values: 0, menuPermission: []
  };

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('sms', this.props.menus);
    this.setState({ menuPermission })
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  onChange(val) {
    this.setState({
      values: val
    });
  }

  render() {
    const { classes, theme } = this.props;
    let x, y, z, section, category, brand;
    if (this.state.values == 0) {
      x = (<Single menuPermission={this.state.menuPermission} />);
    }
    if (this.state.values == 1) {
      y = (<Multiple menuPermission={this.state.menuPermission} />);
    }
    if (this.state.values == 2) {
      z = (<Report menuPermission={this.state.menuPermission} />);
    }

    return (
      <div className={classes.root}>
        <Title title={'SMS'} openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ?
            (
              <div>
                <AppBar position="static" color="default">
                  <Tabs value={this.state.value} onChange={this.handleChange}
                    indicatorColor="primary" textColor="primary" variant="fullWidth">
                    <Tab label="Single SMS" onClick={this.onChange.bind(this, 0)} />
                    <Tab label="Bulk SMS" onClick={this.onChange.bind(this, 1)} />
                    <Tab label="Report" onClick={this.onChange.bind(this, 2)} />
                  </Tabs>
                </AppBar>
                <SwipeableViews axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                  index={this.state.value} onChangeIndex={this.handleChangeIndex}>
                  {x}{y}{z}
                </SwipeableViews>
              </div>
            ):
            (
              <div>
                <center>You are not allow to access this menu!!!</center>
              </div>
            )
        }
      </div>
    );
  }
}

Addmenu.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Addmenu);
